import { createSystem, defaultConfig, defineRecipe } from '@chakra-ui/react'

const inputRecipe = defineRecipe({
  variants: {
    variant: {
      subtle: {
        bg: 'gray.100',
      },
    },
  },
});

const buttonRecipe = defineRecipe({
  base: {
    colorPalette: 'primary',
  },
  variants: {
    variant: {
      solid: {
        bg: 'colorPalette.500',
        color: 'white',
        _hover: {
          bg: 'colorPalette.600',
        },
      },
      outline: {
        border: '1px solid',
        color: 'colorPalette.500',
        _hover: {
          bg: 'colorPalette.50',
        }
      },
      ghost: {
        color: 'fg.muted',
      }
    },
  },
});

export const system = createSystem(defaultConfig, {
  theme: {
    tokens: {
      fonts: {
        heading: { value: `'Montserrat', sans-serif` },
        body: { value: `'Montserrat', sans-serif` },
      },
      colors: {
        primary: {
          50: { value: '#F3E8FA' },
          100: { value: '#E0C8F0' },
          200: { value: '#C7A3E3' },
          300: { value: '#AD7ED6' },
          400: { value: '#9459C9' },
          500: { value: '#6A2C91' },
          600: { value: '#5B257D' },
          700: { value: '#4B1E68' },
          800: { value: '#3C1753' },
          900: { value: '#2C103E' },
        },
        secondary: {
          50: { value: '#FFF3E8' },
          100: { value: '#FFE0C2' },
          200: { value: '#FFC999' },
          300: { value: '#FFB26F' },
          400: { value: '#FF9B45' },
          500: { value: '#F58220' },
          600: { value: '#DB741D' },
          700: { value: '#B85F18' },
          800: { value: '#944A13' },
          900: { value: '#70350E' },
        },
      },
    },

    semanticTokens: {
      colors: {
        bg: {
          DEFAULT: {
            value: '{colors.gray.100}',
          },
        },
        primary: {
          contrast: { value: { _light: 'white', _dark: 'white' } },
          fg: { value: { _light: '{colors.primary.700}', _dark: '{colors.primary.300}' } },
          subtle: { value: { _light: '{colors.primary.100}', _dark: '{colors.primary.900}' } },
          muted: { value: { _light: '{colors.primary.200}', _dark: '{colors.primary.800}' } },
          emphasized: { value: { _light: '{colors.primary.300}', _dark: '{colors.primary.700}' } },
          solid: { value: { _light: '{colors.primary.500}', _dark: '{colors.primary.500}' } },
          focusRing: { value: { _light: '{colors.primary.500}', _dark: '{colors.primary.500}' } },
          border: { value: { _light: '{colors.primary.500}', _dark: '{colors.primary.400}' } },
        },
      },
    },

    recipes: {
      input: inputRecipe,
      button: buttonRecipe,
    },
  },
});
